<section
  class="digitalSolutionsDetail"
  [ngStyle]="{ 'background-image': 'url(' + backgroundImageUrl() + ')' }"
>
  <div class="breadcrums-tracsa">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <ul>
            <li>
              <a routerLink="/">Inicio</a>
              <i class="iconTracsa icon-arrowsmall">&#xe808;</i>
            </li>
            <li>
              <a routerLink="/soluciones-digitales">Soluciones digitales</a
              ><i class="iconTracsa icon-arrowsmall">&#xe808;</i>
            </li>
            <li class="current yellow">{{ solution().name }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <h1 class="title">
      {{ solution().name }}
    </h1>
    <p class="shortDescription">
      {{ solution().shortDescription }}
    </p>
    @if (solution().iosLink !== '' && solution().iosLink !== 'no' && solution().androidLink !== ''
    && solution().androidLink !== 'no') {
    <p class="downloadApp">DESCARGA LA APP</p>
    }
    <div class="links">
      @if (solution().iosLink !== '' && solution().iosLink !== 'no') {
      <a [href]="solution().iosLink" target="_blank" rel="noopener noreferrer" class="external">
        <div class="contentImage">
          <img ngSrc="/solutions/icon-app-store-w.webp" alt="icono app store" fill />
        </div> </a
      >}@if (solution().androidLink !== '' && solution().androidLink !== 'no') {
      <a [href]="solution().androidLink" target="_blank" rel="noopener noreferrer" class="external">
        <div class="contentImage">
          <img ngSrc="/solutions/icon-google-play-w.webp" alt="icono play store" fill /></div
      ></a>
      }
    </div>
  </div>
</section>

<div [innerHTML]="solution().content | safehtml"></div>

<section class="moreDigitalSolutions">
  <div class="container">
    <h2 class="title">Soluciones digitales: tecnología cat que impulsa tu operación</h2>
    <p class="shortDescription">
      Con el ecosistema digital Cat® todo es más fácil. Consulta manuales, compra refacciones,
      monitorea tu flota y realiza reparaciones con total confianza. SIS2GO, VisionLink,
      <a
        href="https://parts.cat.com/es/tracsa?utm_source=website&utm_medium=referral&utm_campaign=PCC&utm_id=PCC"
        target="_blank"
        rel="noopener noreferrer"
        >Parts.Cat.Com</a
      >
      y Self Service Option están diseñados para darte control y rapidez desde cualquier
      dispositivo.
    </p>
    <div class="grid">
      @for (solution of solutions(); track $index) {
      <app-card-solution [solution]="solution" [showApps]="false"></app-card-solution>
      }
    </div>
  </div>
</section>
